import { render, staticRenderFns } from "./2021-1-5-code.vue?vue&type=template&id=7cb7f767&scoped=true&"
import script from "./2021-1-5-code.vue?vue&type=script&lang=ts&"
export * from "./2021-1-5-code.vue?vue&type=script&lang=ts&"
import style0 from "./2021-1-5-code.vue?vue&type=style&index=0&id=7cb7f767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb7f767",
  null
  
)

export default component.exports